import React from 'react';
import * as Tooltip from '@radix-ui/react-tooltip';

const CustomToolTips = ({ ToolTipContent, ToolTipMessage }: any) => {
  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <button className="IconButton">{ToolTipContent}</button>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            className="data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade
               relative z-50 mr-2 select-none rounded-[4px] border border-silverGray bg-white px-3 pb-3 pt-2 text-sm leading-4 text-black
              drop-shadow-lg will-change-[transform,opacity]"
            sideOffset={5}
          >
            {ToolTipMessage}
            <Tooltip.Arrow className="fill-white drop-shadow-lg" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export default CustomToolTips;
